import * as next from 'next'

import * as contentful from '@boutique/contentful'

export { Page as default } from '@boutique/about'
import { type PageProps } from '@boutique/about'

export async function getStaticProps({
  params,
}: next.GetStaticPropsContext<{ slug: string }>): Promise<next.GetStaticPropsResult<PageProps>> {
  const slug = params?.slug

  if (slug === undefined) {
    return {
      notFound: true,
    }
  }

  const response = await contentful.boutiqueAboutPage.getBoutiqueAboutPage({ slug })

  const data = response.doThrow()

  return {
    props: {
      aboutPage: data.boutiqueAboutPageCollection.items[0],
    },
    revalidate: 5,
  }
}

export async function getStaticPaths(): Promise<next.GetStaticPathsResult> {
  const paths: { params: { slug: string } }[] = []

  const collectionResult = await contentful.boutiqueAboutPage.getBoutiqueAboutPageList()

  collectionResult.caseOf({
    right: (collection) => {
      if (collection.boutiqueAboutPageCollection) {
        for (const boutiqueAboutPage of collection.boutiqueAboutPageCollection.items) {
          paths.push({
            params: { slug: boutiqueAboutPage.slug },
          })
        }
      }
    },
    left: () => {
      console.log('failed service')
    },
  })

  return {
    paths,
    fallback: false,
  }
}
